import ReloadPreview from '@components/sources/source/warehouseSource/configureData/tableMapping/reloadPreview';
import { Skeleton } from 'antd';
import * as React from 'react';
import DestinationConnectionConfig from './config/destConfig';
import ConnectionDataMapping from './config/mappingConfig';
import {
  RefreshButtonTextProps,
  refreshColumnsSetup,
  refreshFieldsSetup,
  reloadButton,
} from './config/mappingConfig/SelectUniqueIdentifier';
import SourceConnectionConfig from './config/sourceConfig';
import SyncBehaviourConfig from './config/syncBehaviourConfig';
import { fetchErrorAssets } from './errorsView';
import { generatePreview } from './sourceUtil';
import classes from './visual-mapping.module.scss';
import { useConnectionState } from './visualDataMappingProvider';
import { isCompleteSourceConfig } from './visualMapping';

const ConnectionConfig: React.FC = () => {
  const {
    sourceConfig,
    destinationConfig,
    source,
    ifUpdate,
    viewOnly,
    destination,
    columns,
    fields,
    preview,
    modelAccountId,
    updateSchemaErrors,
    setPreview,
  } = useConnectionState();

  const colRefreshButtonGenerator = (props: RefreshButtonTextProps) =>
    reloadButton(props, 'columns');
  const fieldRefreshButtonGenerator = (props: RefreshButtonTextProps) => (
    <span className={classes.reload_fields_wrapper}>{reloadButton(props, 'fields')}</span>
  );

  const skipSchemaConfiguration = source?.sourceDef?.name.toLowerCase() === 's3';
  const completeSourceConfig = isCompleteSourceConfig(sourceConfig, skipSchemaConfiguration);
  const completeDestinationConfig = !!destinationConfig?.object;
  const [sourceLoading, setSourceLoading] = React.useState(false);
  const [destLoading, setDestLoading] = React.useState(false);
  const isNoColumns = completeSourceConfig && columns.length === 0 && !sourceLoading;
  const isNoFields = completeDestinationConfig && fields.length === 0 && !destLoading;

  let reloadSection;
  if (isNoColumns || isNoFields) {
    reloadSection = (
      <div className={classes.no_fields_columns_container}>
        <div className={classes.reload_buttons_wrapper}>
          {completeSourceConfig &&
            columns.length === 0 &&
            !sourceLoading &&
            refreshColumnsSetup(false, colRefreshButtonGenerator)}
          {completeDestinationConfig &&
            fields.length === 0 &&
            !destLoading &&
            refreshFieldsSetup(
              false,
              fieldRefreshButtonGenerator,
              (val: boolean) => val && updateSchemaErrors([fetchErrorAssets('fields')]),
            )}
        </div>
      </div>
    );
  } else if (
    completeSourceConfig &&
    completeDestinationConfig &&
    Object.keys(preview).length === 0
  ) {
    reloadSection = (
      <ReloadPreview
        sourceConfig={{
          accountId: modelAccountId || source?.config?.accountId || source?.config?.rudderAccountId,
          table: sourceConfig.table?.name,
          ...sourceConfig.table,
          sqlModelId: sourceConfig.sqlModelId,
        }}
        role={source.sourceDef?.name || ''}
        refreshPreview={(rows: Record<string, unknown>[]) => {
          const newPreview = generatePreview(rows, columns);
          setPreview(newPreview);
        }}
        hide={false}
        updateSchemaErrors={updateSchemaErrors}
      />
    );
  }
  return (
    <div
      className={`${classes.visual_mapping_container} ${destination.id ? classes.connect_dest : ''} 
    ${viewOnly || ifUpdate ? 'configure-data__container' : ''}`}
    >
      <div className={classes.source_destination_sync_behaviour__container}>
        <SourceConnectionConfig setLoading={setSourceLoading} />

        <DestinationConnectionConfig onChangeLoadingState={setDestLoading} />

        {completeSourceConfig && completeDestinationConfig && <SyncBehaviourConfig />}
      </div>

      {completeSourceConfig &&
        completeDestinationConfig &&
        Object.keys(preview).length > 0 &&
        (!(destLoading || sourceLoading) ? (
          <ConnectionDataMapping />
        ) : (
          <Skeleton active paragraph={{ rows: 4 }} />
        ))}

      {reloadSection}
    </div>
  );
};

export default ConnectionConfig;
